import styled from "styled-components";
import { device } from "../../Utils/device";
import { themes } from "../../Utils/themes";

export const TopWrap = styled.div`
  padding: 80px 20px 0;
  @media ${device.tablet} {
    padding: 80px 40px;
  }
  @media ${device.desktop} {
    padding: 50px auto;
  }
`;
export const BannerWrap = styled.div`
  width: 100%;
  margin: 0 auto;
  background-color: ${themes.colors.white};
  max-width: 900px;
`;

export const MainBanner = styled.img`
  width: 100%;
  max-width: 900px;
`;

export const FlexList = styled.ul`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-content: flex-start;
  max-width: 1200px;
  margin: 0px auto 20px;
  @media ${device.desktop} {
    margin: 40px auto 20px;
  }
`;

export const ListItem = styled.li`
  position: relative;
  background-color: ${themes.colors.secondary};
  color: ${themes.colors.white};
  display: flex;
  flex-direction: column;
  justify-content: inherit;
  align-items: center;
  margin: 0 auto;
  width: 100%;
  max-width: 190px;
  padding: 0 30px 15px;
  margin: 0px auto 20px;
  box-shadow: 0px 8px 16px -2px rgba(10, 10, 10, 0.1),
    2px 1px 10px 2px rgba(10, 10, 10, 0.02);
  border-radius: 8px;
  border: 1px solid ${themes.colors.border};
  outline: 2px solid ${themes.colors.white};
  outline-offset: -5px;
  @media ${device.desktop} {
    padding: 0 50px 24px;
  }
`;

export const PointImg = styled.img`
  width: 90px;
  min-height: 90px;
  margin-top: 15px;
  @media ${device.desktop} {
    width: 140px;
    min-height: 140px;
    margin-top: 20px;
  }
`;

export const PointLabel = styled.div`
  position: relative;
  display: inline-block;
  width: 100%;
  max-width: 160px;
  height: 25px;
  line-height: 25px;
  color: ${themes.colors.attention};
  font-size: ${themes.textSize.m2};
  font-weight: bold;
  background-color: ${themes.colors.white};
  box-sizing: border-box;
  border: 3px solid ${themes.colors.attention};
  border-top: 0;
  border-radius: 0 0 8px 8px;
  text-align: center;
  @media ${device.desktop} {
    max-width: 190px;
    height: 30px;
    line-height: 30px;
    font-size: ${themes.textSize.m3};
  }
`;

export const PointTitle = styled.h3`
  font-family: "游明朝", "Yu Mincho", YuMincho, "Hiragino Mincho Pro", serif;
  font-size: ${themes.textSize.m2};
  font-weight: bold;
  text-decoration: underline;
  text-decoration-style: double;
  text-underline-offset: 8px;
  @media ${device.desktop} {
    font-size: ${themes.textSize.m3};
  }
`;

export const PointDescription = styled.p`
  font-size: ${themes.textSize.s3};
  line-height: 1.8;
  width: 100%;
  height: 100%;
  @media ${device.desktop} {
    font-size: ${themes.textSize.m1};
  }
`;

export const PointAttention = styled.span`
  font-size: ${themes.textSize.s1};
  width: 100%;
  @media ${device.desktop} {
    font-size: ${themes.textSize.s1};
  }
`;
